export const twistyButtonExpandConversationLabel = "$Lb";
export default {twistyButtonExpandConversationLabel};